import React, { useEffect, useState } from "react";
import SplashVideoFile from "../assets/image/Splash_PatentWeb_new.mp4";
import "../style/component/splash.css"
const SplashVideo = ({ onFinish }) => {
    const [hideVideo, setHideVideo] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setHideVideo(true);
      onFinish();
    }, 4050); 

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div className={`splash-video ${hideVideo ? "video-hide" : ""}`}>
      <video muted={true} autoPlay={true} >
        <source src={SplashVideoFile} type="video/mp4" />
      </video>
    </div>
  );
};

export default SplashVideo;
